import React from "react";
import CustomPopover from "../../Popover";
import Tooltip from "../../Tooltip";

type Props = {
  variables: Record<string, string | null> | undefined;
  insert: (inserted: string, inserted_length?: number) => void;
};

const VariableSelector = ({ variables, insert }: Props) => {
  const disabled = Object.keys(variables || {}).length === 0;
  return (
    <CustomPopover
      disabled={disabled}
      position="top"
      button={
        <Tooltip text="Insérer des variables personnelles" position="bottom">
          <div
            className={`relative flex items-center justify-center text-base bg-gray-100 rounded-full ${
              disabled ? "text-gray-400" : "text-brand_main"
            } size-9 hover:bg-gray-200`}
          >
            $V
          </div>
        </Tooltip>
      }
      panelClasses="drop-shadow-sm"
    >
      <div
        className={`flex flex-col py-2 border rounded bg-white h-32 overflow-y-auto`}
      >
        {Object.keys(variables || {}).map((variable) => {
          const variableLength = variables?.[variable]?.length;
          return (
            <button
              key={`variable_${variable}`}
              className="px-4 py-1 text-sm font-medium text-gray-700 cursor-pointer hover:text-brand_main hover:bg-gray-100"
              onClick={() =>
                insert(variable, variableLength ? variableLength + 1 : 1)
              }
            >
              {variable}
            </button>
          );
        })}
      </div>
    </CustomPopover>
  );
};

export default VariableSelector;
